import React from 'react'
import { Progress } from 'antd'
import classNames from 'classnames'
import { Link, useLocation } from 'react-router-dom'
import ProfileMenu from 'components/layout/WelcomeHeader/UserMenu/index'
import constants from '../../../constants'
import style from './style.module.scss'

const WelcomeHeader = ({ step, totalSteps, showProfile=true }) => {
  const multiplier = typeof totalSteps === 'number' ? 100 / totalSteps : 20
  const location = useLocation()
  const { pathname } = location

  return (
    <div className={classNames(style.welcomeHeader, 'custom-welcome-header')}>
      <div style={{ flex: 1 }}>
        {constants.avoidOnboardingActionsRoutes.some(path => pathname.includes(path)) ? (
          <div className={style.welcomeHeaderLogo} />
        ) : (
          <Link to="/apps" style={{ display: 'block', width: 'fit-content' }}>
            <div className={style.welcomeHeaderLogo} />
          </Link>
        )}
      </div>
      {step && (
        <Progress
          percent={typeof step === 'number' ? Math.round(step) * multiplier : multiplier}
          steps={typeof totalSteps === 'number' ? totalSteps : 5}
          strokeColor="#6938EF"
          trailColor="#E9EAEB"
          size={{ width: 25, height: 6 }}
          showInfo={false}
        />
      )}
      {showProfile && (
        <div className={style.profileWrapper}>
          <ProfileMenu pathname={pathname} />
        </div>
      )}
    </div>
  )
}

export default WelcomeHeader
